export default __webpack_public_path__ + "7790ca14e05d0814524cf1a36a47523c.woff";